import React from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody } from 'reactstrap';
import sitback from './sitback.jpeg';


function Success() {
  const navigate = useNavigate();

  function logout() {
    navigate("/");
  }
  
  return (
    <Card
        color="dark"
        style={{width: '20rem', margin: "0 auto", marginTop: "16vh"}}>
        <img
          alt="Zero Gravity"
          src="https://atzerogravity.com/wp-content/uploads/2021/11/ZG_Logo_web.png" />
        <CardBody style={{"textAlign" : "center"}}>
            <img
              alt="Zero Gravity"
              style={{"height" : "200px"}}
              src={sitback} />
        </CardBody>
        <CardBody>
          <Button color="light" onClick={logout} style={{marginTop: "20px", width: "100%"}}>Logout</Button>
        </CardBody>

      </Card>
  );
}

export default Success;
